import { useQuery } from "@tanstack/react-query";
import React from "react";

import { GraphQLAPI, GraphQLResult, queries } from "@examspark/api";
import { useModal } from "@examspark/common-app";
import { Button, Modal, Text, VSpace } from "@examspark/common-ui";
import { IconSwitchLanguageLine } from "@examspark/common-ui/dist/components/icons";
import { PaddedBody } from "@examspark/common-ui/dist/components/modals/Modal";
import { AnyResource, ModelResourceConnection } from "@examspark/types";

import BrowseList from "../browse/BrowseList";

const NavigateToTranslationButton = (props: { resource: AnyResource }) => {
  const modal = useModal();
  const { data } = useQuery({
    queryKey: ["translations", props.resource.id],
    queryFn: async () => {
      const result = (await GraphQLAPI.query({
        query: queries.relative.listRelatives,
        variables: {
          id: props.resource.id,
          sk: {
            beginsWith: "relative:",
          },
        },
      })) as GraphQLResult<{
        listResources: ModelResourceConnection;
      }>;

      return result;
    },
  });

  const translation = data?.data?.listResources.items?.[0];
  if (!translation) return null;

  return (
    <>
      <Modal
        {...modal}
        title="Go to Translation"
        onRequestClose={() => modal.setIsOpen(false)}
      >
        <PaddedBody>
          <VSpace>
            <Text.Body>
              This content is available in multiple languages. You may navigate
              directly to these translations using the links below.
            </Text.Body>
            <BrowseList
              data={data.data?.listResources.items?.map(
                (data) => data.resource as any,
              )}
              onResultNavigate={() => {
                modal.setIsOpen(false);
              }}
            />
          </VSpace>
        </PaddedBody>
      </Modal>
      <Button
        title="Navigate"
        variant="outlined"
        onClick={() => {
          if (translation.resource == null) return;
          modal.setIsOpen(true);
          // const url = getUrlForObject(translation.resource);
          // if (!url) return;
          // navigate(url);
        }}
      >
        <IconSwitchLanguageLine width="16" />
        ENG/SPN
      </Button>
    </>
  );
};

export default NavigateToTranslationButton;
